import { TeamRosterFragment } from '@amf/shared/types/graphql';
import { TeamRosterFilterData } from '@amf/shared/components/team/TeamRosterFilter';
import { sdk } from '@amf/shared/lib/graphQlClient';

export const getCacheKey = ({ season, league, team }: TeamRosterFilterData & { team: string }) => {
  const params = new URLSearchParams({ season, league, team });
  return `/api/team/roster?${params}`;
};

export async function getTeamRoster(
  teamId: string,
  seasonId: string,
  leagueId: string | null = null,
): Promise<TeamRosterFragment | null> {
  const { roster } = await sdk.TeamRoster({
    union: process.env.NEXT_PUBLIC_UNION,
    id: teamId,
    season: seasonId,
    league: leagueId ?? undefined,
  });
  return roster;
}
